import { NativeSurveyState } from './reducer';
import { hasSurveyInteraction } from './request';

export const nativeSurveyVisible = (state: NativeSurveyState) => !!state.binding &&
  (!!state.form || !!state.recoveryMode || state.refreshFailed);

export const nativeSurveyBlocksComposer = (state: NativeSurveyState) => {
  if (!state.binding) return false;
  if (state.pending || state.recovered[state.recovered.length - 1]?.pendingInteractionId) return true;
  if (!state.form) return !!state.recoveryMode;
  if (['completed', 'ended'].includes(state.form.status)) return false;
  const displayOnly = state.phase === 'readOnly' && !state.disconnected && !state.error &&
    !state.refreshResponseId && ['idle', 'ready'].includes(state.recoveryStatus) && !hasSurveyInteraction(state.form);
  return !displayOnly;
};